import React, { useContext } from 'react';
import classNames from 'classnames';
import { AccordionGroupContext, AccordionContext } from '../../context';

const AccordionGroup = ({ children, itemId }) => {
  const { appearance } = useContext(AccordionContext);

  const classes = classNames('ws-ui-accordion-group', `ws-ui-accordion-group--${appearance}`);

  return (
    <AccordionGroupContext.Provider value={itemId}>
      <div className={classes}>{children}</div>
    </AccordionGroupContext.Provider>
  );
};

export default AccordionGroup;
